import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { REFERENCE_KEY, REQUESTREFERENCE } from '@common/constants';
import { IAdditionalFields } from '@common/models';
import { ResultPageService, ResultService } from '@common/services';
import { BaseFpxFormComponent } from '@common/utils';
import { TranslateService } from '@ngx-translate/core';
import { CommonService } from 'src/app/common.service';
import { RetailStock } from 'src/app/retail-common.service';
import { CustomerService } from 'src/app/services/customer.service';
import { FileOpenerService } from 'src/app/services/mobile/file-opener.service';
import { ServiceRequestHistoryService } from 'src/app/services/service-request-history/service-request-history.service';
import { SellOrderHelper, SellOrderState } from './services/sell-order.helper';

@Component({
  selector: 'app-sell-order',
  templateUrl: './sell-order.component.html',
  styleUrls: ['./sell-order.component.scss']
})
export class SellOrderComponent extends BaseFpxFormComponent<SellOrderHelper, SellOrderState> {
  //mutualInfo:IMutualFundsProduct
  errorType = 'error';
  requestReference: any;
  constructor(
    _formBuilder: FormBuilder,
    private _router: Router,
    public _sellOrderHelper: SellOrderHelper,
    private _resultService : ResultService,
    private _commonService: CommonService,
    private _customerInfo: CustomerService,
    protected translate:TranslateService,
    private _retailStock:RetailStock,
    private _serviceRequestHistoryService: ServiceRequestHistoryService,
    private _fileOpner:FileOpenerService
   // private _depositInfo: DepositInfo
   
  ) {
    super(_formBuilder, _router, _sellOrderHelper);
  }

  protected override doPreInit(): void {
    this.initializeForm();
    if(this._commonService.isDesktop()) {
      this._retailStock.searchRequired = true;
      this._retailStock.serviceDescription = 'CONTEXTULAMENU.sellOrder';
      this._retailStock.backBtnUrl = ['home','transactions'];
    }
    this.requestReference = this._serviceRequestHistoryService.getTrackerDetails()?.requestReference;
    if(this.requestReference) {
      this.state.disableMode = true;
      this._sellOrderHelper.fetchSellOrderDetails(this.requestReference, this.formGroup);
    }

  }
  ngOnDestroy(): void {
    this._retailStock.backBtnUrl = undefined;
    this._sellOrderHelper.resetState();
  }
  initializeForm() {
    const accountNumber = this.getRoutingParam(REFERENCE_KEY);
    this.addFormControl("accountNumber",accountNumber, [Validators.required], [], "change");
    this.addFormControl("noOfUnits","", [Validators.required], [], "change");
    this.addFormControl("termsCondition", "",[Validators.required],[],"change");
     
    
  }
  
submit(): void {
  this.formGroup.disable({ emitEvent : false });
  this.state.disableMode=true;
}
edit(){
  this.formGroup.enable({emitEvent : false});
  this.state.disableMode=false;
}
  override doConfirm(formGroup: FormGroup) {
    this._sellOrderHelper.doConfirm(formGroup.value,  (res) => {
        this.navigateToResultPage(this._resultService.resultPageData);
    },
    (err) => {
       this.navigateToResultPage(this._resultService.resultPageData);
    });
  }


  reset() {
    this.formGroup.get('noOfUnits').reset();
    this.formGroup.get('termsCondition').reset();
    this.state.disableMode=false;
  }
  openDocument() {
    if(this._commonService.isHybrid()){
      this._fileOpner.openTermsPDF('Terms.pdf');
    } else {
      this._commonService.openDocument('Terms.pdf');
    }
  }
}
